(function () {
  'use strict';

  var routes = (window.Theme && window.Theme.routes) || {};

  // Renders cents to a display string using the shop's money format.
  // The shop's format may contain HTML (e.g. <span class=money>${{amount}}</span>);
  // since we assign the result via textContent, strip any tags so the markup
  // never shows up as literal text next to the price.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var format = (window.Theme && window.Theme.moneyFormat) || '${{amount}}';
    var out = format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
    if (out.indexOf('<') !== -1) {
      var tmp = document.createElement('div');
      tmp.innerHTML = out;
      out = (tmp.textContent || tmp.innerText || '').trim();
    }
    return out;
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
    mobileMenu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        mobileMenu.hidden = true;
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.focus();
      }
    });
  }

  /* ---------------- Search modal ---------------- */
  var searchModal = document.querySelector('[data-search-modal]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimer;
  var searchRequest = 0;

  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal && typeof searchModal.showModal === 'function') {
        searchModal.showModal();
        if (searchInput) searchInput.focus();
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) searchModal.close();
    });
  });
  if (searchModal) {
    searchModal.addEventListener('click', function (event) {
      if (event.target === searchModal) searchModal.close();
    });
  }
  if (searchInput && routes.predictiveSearchUrl) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      var requestId = ++searchRequest;
      searchResults.textContent = '';
      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        var url =
          routes.predictiveSearchUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('Search failed');
            return res.json();
          })
          .then(function (data) {
            if (requestId !== searchRequest) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.textContent = window.Theme.strings.searchEmpty;
              return;
            }
            searchResults.replaceChildren();
            products.forEach(function (product) {
              var link = document.createElement('a');
              link.className = 'search-modal__result';
              link.href = product.url;
              if (product.featured_image && product.featured_image.url) {
                var image = document.createElement('img');
                image.src = product.featured_image.url;
                image.alt = '';
                image.loading = 'lazy';
                link.appendChild(image);
              }
              var title = document.createElement('span');
              title.className = 'search-modal__result-title';
              title.textContent = product.title;
              link.appendChild(title);
              searchResults.appendChild(link);
            });
          })
          .catch(function () {
            if (requestId === searchRequest) searchResults.textContent = window.Theme.strings.searchError;
          });
      }, 220);
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function openCartDrawer() {
    if (cartDrawer && typeof cartDrawer.showModal === 'function') {
      cartDrawer.showModal();
    }
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.close();
  }
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-close]')) closeCartDrawer();
  });
  document.addEventListener('click', function (event) {
    if (cartDrawer && event.target === cartDrawer) closeCartDrawer();
  });

  function refreshCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function showCartError(container) {
    if (!container) return;
    var error = container.querySelector('[data-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-cart-error', '');
      error.setAttribute('role', 'alert');
      container.appendChild(error);
    }
    error.textContent = window.Theme.strings.cartError;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) {
      return res.json();
    });
  }

  function reloadCartDrawer() {
  return fetch(window.location.pathname + window.location.search)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');

      if (fresh && cartDrawer) {
        var wasOpen = cartDrawer.open;

        cartDrawer.replaceWith(fresh);
        cartDrawer = fresh;

        if (wasOpen && typeof cartDrawer.showModal === 'function') {
          cartDrawer.showModal();
        }
      }
    });
}

function reloadCartPage() {
  var currentCartPage = document.querySelector('.cart-page');

  if (!currentCartPage) {
    return Promise.resolve();
  }

  return fetch(window.location.pathname + window.location.search)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshCartPage = doc.querySelector('.cart-page');

      if (freshCartPage && currentCartPage) {
        currentCartPage.replaceWith(freshCartPage);
      }
    });
}

/* Cart drawer + cart page quantity/remove */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-cart-change]');
  if (!btn) return;

  event.preventDefault();

  if (btn.getAttribute('aria-busy') === 'true') return;

  btn.setAttribute('aria-busy', 'true');

  var line = parseInt(btn.getAttribute('data-line'), 10);
  var quantity = parseInt(btn.getAttribute('data-quantity'), 10);

  fetch(routes.cartChangeUrl || '/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    })
    .then(function (cart) {
      refreshCartCount(cart);

      return Promise.all([
        reloadCartDrawer(),
        reloadCartPage()
      ]);
    })
    .catch(function () {
      btn.removeAttribute('aria-busy');
      showCartError(btn.closest('[data-cart-drawer]') || btn.closest('.cart-page'));
    });
});

  function bindCartDrawerEvents() {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('[data-line-quantity]').forEach(function (wrap) {
      var line = wrap.getAttribute('data-line');
      var input = wrap.querySelector('[data-line-quantity-input]');
      var dec = wrap.querySelector('[data-quantity-decrease]');
      var inc = wrap.querySelector('[data-quantity-increase]');

      function changeLine(qty) {
        fetch(routes.cartChangeUrl || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            refreshCartCount(cart);
            reloadCartDrawer();
          });
      }

      if (dec) {
        dec.addEventListener('click', function () {
          changeLine(Math.max(0, parseInt(input.value, 10) - 1));
        });
      }
      if (inc) {
        inc.addEventListener('click', function () {
          changeLine(parseInt(input.value, 10) + 1);
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          changeLine(Math.max(0, parseInt(input.value, 10) || 0));
        });
      }
    });
  }
  bindCartDrawerEvents();

  /* Intercept every product add-to-cart form on the page (quick-add cards + PDP) */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    fetch(routes.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form).entries()))
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
  refreshCartCount(cart);

  return Promise.all([
    reloadCartDrawer(),
    reloadCartPage()
  ]);
})
.then(function () {
  setTimeout(openCartDrawer, 60);
})
      .catch(function () {
        showCartError(form);
      })
      .finally(function () {
        form.removeAttribute('aria-busy');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  });

  /* ---------------- Generic quantity steppers (PDP, standalone) ---------------- */
  document.addEventListener('click', function (event) {
    var decBtn = event.target.closest('[data-quantity-decrease]');
    var incBtn = event.target.closest('[data-quantity-increase]');
    var btn = decBtn || incBtn;
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-selector]');
    if (!wrap) return;
    var input = wrap.querySelector('.quantity-selector__input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    value = decBtn ? Math.max(1, value - 1) : value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Sticky product bar reveal ---------------- */
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');
  var buyBoxAnchor = document.querySelector('[data-buy-box-anchor]');
  if (stickyBar && buyBoxAnchor && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    observer.observe(buyBoxAnchor);
  }

  /* ---------------- Defer to a subscriptions app's own widget, if any ---------------- */
  var appManagedFallbacks = document.querySelectorAll('[data-app-managed-fallback]');
  if (appManagedFallbacks.length) {
    var APP_WIDGET_SELECTOR =
      '.sealsubs-container, [class*="subscription-widget"], [class*="selling-plan-widget"], [data-selling-plan-widget], [id*="subscription_app"]';

    function hideFallbacksIfAppPresent() {
      if (document.querySelector(APP_WIDGET_SELECTOR)) {
        appManagedFallbacks.forEach(function (fallback) {
          fallback.hidden = true;
        });
        return true;
      }
      return false;
    }

    if (!hideFallbacksIfAppPresent()) {
      var appWidgetObserver = new MutationObserver(function () {
        if (hideFallbacksIfAppPresent()) appWidgetObserver.disconnect();
      });
      appWidgetObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        appWidgetObserver.disconnect();
      }, 8000);
    }
  }

  /* ---------------- Selling plan (one-time vs subscribe) toggle ---------------- */
  document.querySelectorAll('[data-purchase-option]').forEach(function (radio) {
  radio.addEventListener('change', function () {
    var form = radio.closest('form');
    if (!form) return;

    var sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    var frequencySelect = form.querySelector('[data-selling-plan-select]');

    if (!sellingPlanInput) return;

    var submitPrice = form.querySelector('[data-submit-price]');
    var oneTimePrice = form.querySelector('[data-one-time-price]');
    var subscriptionPrice = form.querySelector('[data-subscription-price]');

    if (radio.value === 'subscription') {
      sellingPlanInput.value =
        frequencySelect
          ? frequencySelect.value
          : sellingPlanInput.dataset.defaultPlan || '';

      sellingPlanInput.disabled = false;

      if (frequencySelect) {
        frequencySelect.disabled = false;
      }
    } else {
      sellingPlanInput.value = '';
      sellingPlanInput.disabled = true;

      if (frequencySelect) {
        frequencySelect.disabled = true;
      }
    }

    if (submitPrice) {
      if (radio.value === 'subscription' && subscriptionPrice) {
        submitPrice.textContent = subscriptionPrice.textContent.trim();
      } else if (oneTimePrice) {
        submitPrice.textContent = oneTimePrice.textContent.trim();
      }
    }
  });
});
  document.querySelectorAll('[data-selling-plan-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      var sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');
      if (sellingPlanInput && !sellingPlanInput.disabled) {
        sellingPlanInput.value = select.value;
      }
    });
  });
  /* ---------------- Hero CTA price sync with Seal Subscriptions ---------------- */
  (function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;

    var form = hero.querySelector('.hero__product-form');
    if (!form) return;

    var priceEl = form.querySelector('[data-submit-price]');
    if (!priceEl) return;

    var oneTimePrice = parseInt(
      priceEl.getAttribute('data-one-time-price-cents'),
      10
    );

    var subscriptionPrice = parseInt(
      priceEl.getAttribute('data-subscription-price-cents'),
      10
    );

    function subscriptionIsSelected() {
      /* First inspect visible selected radio buttons from Seal */
      var checkedRadios = hero.querySelectorAll('input[type="radio"]:checked');

      for (var i = 0; i < checkedRadios.length; i++) {
        var radio = checkedRadios[i];
        var row =
          radio.closest('label') ||
          radio.closest('[class*="subscription"]') ||
          radio.closest('[class*="seal"]') ||
          radio.closest('div');

        var text = row ? row.textContent.toLowerCase() : '';

        if (text.indexOf('subscribe') !== -1) {
          return true;
        }

        if (
          text.indexOf('one-time') !== -1 ||
          text.indexOf('one time') !== -1
        ) {
          return false;
        }
      }

      /* Fallback to Shopify selling-plan field */
      var checkedPlan = form.querySelector(
        'input[name="selling_plan"]:checked'
      );

      if (
        checkedPlan &&
        !checkedPlan.disabled &&
        checkedPlan.value
      ) {
        return true;
      }

      var planSelect = form.querySelector(
        'select[name="selling_plan"]'
      );

      if (
        planSelect &&
        !planSelect.disabled &&
        planSelect.value
      ) {
        return true;
      }

      var hiddenPlan = form.querySelector(
        'input[name="selling_plan"][type="hidden"]'
      );

      if (
        hiddenPlan &&
        !hiddenPlan.disabled &&
        hiddenPlan.value
      ) {
        return true;
      }

      return false;
    }

    function syncHeroPrice() {
      var cents = subscriptionIsSelected()
        ? subscriptionPrice
        : oneTimePrice;

      if (isNaN(cents)) return;

      var formatted = formatMoney(cents);

      if (priceEl.textContent.trim() !== formatted) {
        priceEl.textContent = formatted;
      }
    }

    hero.addEventListener('change', function () {
      setTimeout(syncHeroPrice, 0);
      setTimeout(syncHeroPrice, 100);
    });

    hero.addEventListener('click', function () {
      setTimeout(syncHeroPrice, 100);
    });

    var heroPriceObserver = new MutationObserver(function () {
      syncHeroPrice();
    });

    heroPriceObserver.observe(hero, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'checked',
        'value',
        'aria-checked',
        'class'
      ]
    });

    setTimeout(syncHeroPrice, 300);
    setTimeout(syncHeroPrice, 1200);
  })();
  (function () {
    var form = document.getElementById('pdp-form');
    if (!form) return;
    var slot = form.querySelector('[data-subscription-app-slot]');
    if (!slot) return;
    function syncPurchasePrice() {
      var selectedPrice = slot.querySelector('.sls-option-container.sls-active .sls-total-price .money');
      if (!selectedPrice) return;
      var text = selectedPrice.textContent.trim();
      if (!text) return;
      [form.querySelector('[data-submit-price]'), document.querySelector('[data-sticky-price]')].forEach(function (element) {
        if (element && element.textContent.trim() !== text) element.textContent = text;
      });
    }
    new MutationObserver(syncPurchasePrice).observe(slot, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked']});
    form.addEventListener('change', function () { setTimeout(syncPurchasePrice, 0); });
    document.addEventListener('sealsubs:price_update', function () { setTimeout(syncPurchasePrice, 0); });
    syncPurchasePrice();
  })();

  /* ---------------- Gallery thumbnails ---------------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrap = thumb.closest('.pdp__gallery');
      if (!wrap) return;
      var mainImg = wrap.querySelector('[data-gallery-main] img');
      if (mainImg) {
        var responsiveSources = thumb.getAttribute('data-full-srcset');
        if (responsiveSources) mainImg.setAttribute('srcset', responsiveSources);
        else mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-full-src');
        var thumbnailImage = thumb.querySelector('img');
        mainImg.alt = thumbnailImage ? thumbnailImage.alt : '';
      }
      wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
        t.setAttribute('aria-pressed', String(t === thumb));
      });
    });
  });

  /* ---------------- Variant picker ---------------- */
  document.querySelectorAll('[data-product-json]').forEach(function (script) {
    var form = script.closest('form');
    if (!form) return;
    var product;
    try {
      product = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var optionSelectors = Array.from(form.querySelectorAll('[data-option-selector]'));
    var variantInput = form.querySelector('[data-variant-id]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitPrice = form.querySelector('[data-submit-price]');
    var priceWrap = form.closest('.pdp') ? form.closest('.pdp').querySelector('[data-price-wrap]') : null;

    function findVariant() {
      var selected = optionSelectors.map(function (s) {
        return s.value;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return selected.length === 0 || opt === selected[i];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (submitPrice) submitPrice.textContent = formatMoney(variant.price);
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
      }
      if (priceWrap) {
        var amountEl = priceWrap.querySelector('.price__amount');
        if (amountEl) amountEl.textContent = formatMoney(variant.price);
        var compareEl = priceWrap.querySelector('.price__compare');
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }
      // Keep any subscribe-option price in sync with the selected variant.
      var subPriceEl = form.querySelector('[data-subscription-price]');
      if (subPriceEl) {
        var pct = parseFloat(subPriceEl.getAttribute('data-discount-percent') || '15');
        subPriceEl.textContent = formatMoney(Math.round(variant.price * (1 - pct / 100)));
      }
      var oneTimePriceEl = form.querySelector('[data-one-time-price]');
      if (oneTimePriceEl) oneTimePriceEl.textContent = formatMoney(variant.price);
    }

    optionSelectors.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findVariant());
      });
    });
  });
})();
